<template>
  <BreadCrumb PageTitle="Liste des bons de paiments (Livreurs)" />
  <EditPayment />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditPayment from "@/components/Notes/Payments/Driver/EditPayment.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "EditPaymentPage",
  components: {
    BreadCrumb,
    EditPayment,
  },

  setup: () => {
      const route = useRoute();
      let id = route.params.id; 
      if (Array.isArray(id)) {
        id = id[0] ?? "";
      }
  
      let refNote = route.params.refNote; 
      if (Array.isArray(refNote)) {
        refNote = refNote[0] ?? "";
      }
  
  
      return { id , refNote};
  }
  
});
</script>
